import { Form } from "antd";
import { Password } from "@formily/antd-v5";
import { forwardRef, useImperativeHandle } from "react";
import {
  IResetPasswordProps,
  IResetPasswordRefType,
} from "@/utils/types/resetPasswordRef";

const ResetPassword = forwardRef<IResetPasswordRefType, IResetPasswordProps>(
  (props, ref) => {
    const [form] = Form.useForm();

    useImperativeHandle(ref, () => ({
      getFieldsValue: () => form.getFieldsValue(),
      resetFields: () => form.resetFields(),
      validateFields: () => form.validateFields(),
    }));

    return (
      <Form form={form} layout="vertical">
        <Form.Item label="Current Password" name="current_password">
          <Password />
        </Form.Item>
        <Form.Item label="New Password" name="new_password">
          <Password />
        </Form.Item>
      </Form>
    );
  }
);

export default ResetPassword;
